import {Tag} from '@chakra-ui/react';
import React from 'react';

const JcTag = ({color, label, tooltip}) => (
  <Tag
    color="black"
    bg={color}
    borderRadius="none"
    fontSize="sm"
    lineHeight="md"
    textTransform="uppercase"
    tooltip={tooltip}
    // position="relative"
    // top="-4px"
  >
    {label}
  </Tag>
);

export default JcTag;
